import logoEscuro from '@/assets/images/logo/logo-integradoor-dark.svg'
import logoClaro from '@/assets/images/logo/logo-integradoor.svg'
import { useTheme } from '@/utility/context/theme-context'

interface BrandLogoProps {
  className?: string
}

const BrandLogo = ({ className }: BrandLogoProps) => {
  const { theme } = useTheme()

  return (
    <img
      src={theme === 'dark' ? logoEscuro : logoClaro}
      alt="Admin IntegraDoor"
      className={className}
    />
  )
}

export default BrandLogo
